import { render, staticRenderFns } from "./NoteBooks.vue?vue&type=template&id=218a4fea&scoped=true&"
import script from "./NoteBooks.vue?vue&type=script&lang=js&"
export * from "./NoteBooks.vue?vue&type=script&lang=js&"
import style0 from "./NoteBooks.vue?vue&type=style&index=0&id=218a4fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a4fea",
  null
  
)

export default component.exports